import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const QueryAdd2 = (props: SvgIconT.Props) => (
  <SvgIcon width={20} height={20} {...props} viewBox="0 0 20 20">
    <path d="M1 6h12.5c-1.36 0-2.631.367-3.731 1H1V6zm6.51 3H1v1h5.87a7.49 7.49 0 0 1 .64-1zM15 3H1v1h14v2h-1.5a7.47 7.47 0 0 1 2.5.436V0H0v1h15v2zm4 10.5c0 3.025-2.475 5.5-5.5 5.5S8 16.525 8 13.5 10.475 8 13.5 8s5.5 2.475 5.5 5.5zm-2-.5h-3v-3h-1v3h-3v1h3v3h1v-3h3v-1z" />{' '}
  </SvgIcon>
);

export default QueryAdd2;
